var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import conf from "../config";
import axiosClient, { isAxiosError } from "../services/axiosClient";
import { deepCamelCaseKeys, deepSnakeCaseKeys } from "../utils";
import { ApiErrorCode } from "../types";
import tokenRefresh from "./automaticTokenRefresh";
export var LOGOUT_STORAGE_EVENT_KEY = "lionbridge_ai_logout";
var TOKEN_STORAGE_KEY = "lionbridge_ai_token";
export function isExternalIdpAuthAlternative(alternative) {
    return alternative.method === "redirect";
}
export function isIdpPasswordAlternative(alternative) {
    return alternative.method === "password";
}
var inMemoryToken = null;
var storageLogoutHandler = null;
export function _clearAuthTokens() {
    inMemoryToken = null;
    window.localStorage.removeItem(TOKEN_STORAGE_KEY);
}
function _setAuthTokens(token) {
    var tokenStorageLocation = conf.getAuthConfig().tokenStorageLocation;
    if (tokenStorageLocation === "localStorage") {
        window.localStorage.setItem(TOKEN_STORAGE_KEY, JSON.stringify(token));
        return;
    }
    inMemoryToken = token;
}
export function getAuthTokens() {
    var tokenStorageLocation = conf.getAuthConfig().tokenStorageLocation;
    if (tokenStorageLocation === "localStorage") {
        var authTokens = window.localStorage.getItem(TOKEN_STORAGE_KEY);
        return authTokens ? JSON.parse(authTokens) : null;
    }
    return inMemoryToken;
}
export function _clearLogoutHandler() {
    if (storageLogoutHandler === null) {
        return;
    }
    window.removeEventListener("storage", storageLogoutHandler);
    storageLogoutHandler = null;
}
function _deleteSessionCookie() {
    return __awaiter(this, void 0, void 0, function () {
        var apapiUrl, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apapiUrl = conf.getAuthConfig().apapiUrl;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axiosClient.post(apapiUrl + "/oauth/logout", {}, { withCredentials: true })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    throw new Error("Logout failed - session cookie could not be deleted");
                case 4: return [2 /*return*/];
            }
        });
    });
}
function _triggerMultiTabLogoutEvent() {
    window.localStorage.setItem(LOGOUT_STORAGE_EVENT_KEY, new Date().toISOString());
}
export function logoutUser(user, _a) {
    var _b = _a.shouldRedirect, shouldRedirect = _b === void 0 ? true : _b;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!user) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, _deleteSessionCookie()];
                case 1:
                    _c.sent();
                    _clearAuthTokens();
                    _clearLogoutHandler();
                    _triggerMultiTabLogoutEvent();
                    if (shouldRedirect) {
                        window.location.replace(user.logoutRedirectUrl);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function _createLogoutHandler(redirectUrl) {
    return function (event) {
        if (event.key === LOGOUT_STORAGE_EVENT_KEY) {
            _clearAuthTokens();
            _clearLogoutHandler();
            window.location.replace(redirectUrl);
        }
    };
}
function _registerLogoutHandler(user) {
    if (storageLogoutHandler !== null) {
        return;
    }
    var redirectUrl = user.logoutRedirectUrl;
    storageLogoutHandler = _createLogoutHandler(redirectUrl);
    window.addEventListener("storage", storageLogoutHandler);
}
function _scheduleTokenRefresh() {
    var token = getAuthTokens();
    if (!token) {
        return;
    }
    tokenRefresh.scheduleTokenRefresh(token.idTokenExpiresIn, function (newToken) {
        _setAuthTokens(newToken);
    });
}
export function loginUserWithPasswordFactory(idTokenStringToUser) {
    return function loginUserWithPassword(_a) {
        var username = _a.username, password = _a.password;
        return __awaiter(this, void 0, void 0, function () {
            var _b, aud, apapiUrl, tokenData, data, error_1, user;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = conf.getAuthConfig(), aud = _b.aud, apapiUrl = _b.apapiUrl;
                        tokenData = null;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axiosClient.post(apapiUrl + "/oauth/token?aud=" + aud, deepSnakeCaseKeys({
                                username: username,
                                password: password,
                                grantType: "password",
                            }), { withCredentials: true })];
                    case 2:
                        data = (_c.sent()).data;
                        tokenData = deepCamelCaseKeys(data);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        // TODO: Improve error handling
                        return [2 /*return*/, Promise.reject(error_1)];
                    case 4:
                        _setAuthTokens(tokenData);
                        _scheduleTokenRefresh();
                        user = idTokenStringToUser(tokenData.idToken);
                        if (!user) {
                            return [2 /*return*/, null];
                        }
                        _registerLogoutHandler(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
}
export function loginUserThroughRedirect(idpUrl) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            window.location.href = idpUrl;
            return [2 /*return*/];
        });
    });
}
export function getUserLoginAlternatives(_a) {
    var username = _a.username, redirectUri = _a.redirectUri;
    return __awaiter(this, void 0, void 0, function () {
        var _b, aud, apapiUrl, data, _c, authMethods, rest, error_2;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = conf.getAuthConfig(), aud = _b.aud, apapiUrl = _b.apapiUrl;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axiosClient.post(apapiUrl + "/oauth/auth_methods?aud=" + aud + "&redirect_uri=" + encodeURIComponent(redirectUri), { username: username }, { withCredentials: true })];
                case 2:
                    data = (_d.sent()).data;
                    _c = deepCamelCaseKeys(data), authMethods = _c.authMethods, rest = __rest(_c, ["authMethods"]);
                    return [2 /*return*/, __assign(__assign({}, rest), { authAlternatives: authMethods })];
                case 3:
                    error_2 = _d.sent();
                    // TODO: Improve error handling and test it
                    return [2 /*return*/, Promise.reject(error_2)];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function _fetchAuthTokenSilently() {
    return __awaiter(this, void 0, void 0, function () {
        var _a, aud, apapiUrl, responseData, data, authToken;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = conf.getAuthConfig(), aud = _a.aud, apapiUrl = _a.apapiUrl;
                    return [4 /*yield*/, axiosClient.post(apapiUrl + "/oauth/token?aud=" + aud, deepSnakeCaseKeys({ grantType: "refresh_token" }), { withCredentials: true })];
                case 1:
                    responseData = _b.sent();
                    data = responseData.data;
                    authToken = deepCamelCaseKeys(data);
                    return [2 /*return*/, authToken];
            }
        });
    });
}
export function authenticateSilentlyFactory(idTokenStringToUser) {
    return function authenticateSilently() {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var authToken, e_2, errors, user;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        authToken = getAuthTokens();
                        if (authToken) {
                            return [2 /*return*/, idTokenStringToUser(authToken.idToken)];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 6]);
                        return [4 /*yield*/, _fetchAuthTokenSilently()];
                    case 2:
                        authToken = _b.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        e_2 = _b.sent();
                        if (!isAxiosError(e_2)) return [3 /*break*/, 5];
                        errors = JSON.stringify((_a = e_2.response) === null || _a === void 0 ? void 0 : _a.data.errors);
                        if (!(!!errors && errors.includes(ApiErrorCode.CmpOfacError))) return [3 /*break*/, 5];
                        return [4 /*yield*/, _deleteSessionCookie()];
                    case 4:
                        _b.sent();
                        _clearAuthTokens();
                        _clearLogoutHandler();
                        _triggerMultiTabLogoutEvent();
                        throw { errors: ApiErrorCode.CmpOfacError };
                    case 5: throw { errors: "Could not authenticate silently" };
                    case 6:
                        _setAuthTokens(authToken);
                        _scheduleTokenRefresh();
                        user = idTokenStringToUser(authToken.idToken);
                        if (!user) {
                            return [2 /*return*/, null];
                        }
                        _registerLogoutHandler(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
}
export function forceTokenRefresh(sso) {
    return __awaiter(this, void 0, void 0, function () {
        var newTokens;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, tokenRefresh.refreshToken(sso)];
                case 1:
                    newTokens = _a.sent();
                    _setAuthTokens(newTokens);
                    return [2 /*return*/, newTokens];
            }
        });
    });
}
export default {
    loginUserWithPasswordFactory: loginUserWithPasswordFactory,
    loginUserThroughRedirect: loginUserThroughRedirect,
    logoutUser: logoutUser,
    forceTokenRefresh: forceTokenRefresh,
    getAuthTokens: getAuthTokens,
    getUserLoginAlternatives: getUserLoginAlternatives,
    authenticateSilentlyFactory: authenticateSilentlyFactory,
    _createLogoutHandler: _createLogoutHandler,
};
